/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CombinedGoodsListForPackBaseGoodsForPackVo
 */
export interface CombinedGoodsListForPackBaseGoodsForPackVo {
    /**
     * 商品id
     * @type {number}
     * @memberof CombinedGoodsListForPackBaseGoodsForPackVo
     */
    id?: number;
    /**
     * 商品编码
     * @type {string}
     * @memberof CombinedGoodsListForPackBaseGoodsForPackVo
     */
    code?: string;
    /**
     * 商品图片URL
     * @type {string}
     * @memberof CombinedGoodsListForPackBaseGoodsForPackVo
     */
    imgUrl?: string;
    /**
     * 商品构成
     * @type {number}
     * @memberof CombinedGoodsListForPackBaseGoodsForPackVo
     */
    constructQuantity?: number;
    /**
     * 商品名称
     * @type {string}
     * @memberof CombinedGoodsListForPackBaseGoodsForPackVo
     */
    name?: string;
    /**
     * 快递单号
     * @type {string}
     * @memberof CombinedGoodsListForPackBaseGoodsForPackVo
     */
    trackingNumber?: string;
    /**
     * 商品颜色
     * @type {string}
     * @memberof CombinedGoodsListForPackBaseGoodsForPackVo
     */
    color?: string;
    /**
     * 商品尺寸
     * @type {string}
     * @memberof CombinedGoodsListForPackBaseGoodsForPackVo
     */
    size?: string;
    /**
     * 商品长度 cm
     * @type {number}
     * @memberof CombinedGoodsListForPackBaseGoodsForPackVo
     */
    length?: number;
    /**
     * 商品宽度 cm
     * @type {number}
     * @memberof CombinedGoodsListForPackBaseGoodsForPackVo
     */
    width?: number;
    /**
     * 商品高度 cm
     * @type {number}
     * @memberof CombinedGoodsListForPackBaseGoodsForPackVo
     */
    height?: number;
    /**
     * 原产地标作业方式
     * @type {string}
     * @memberof CombinedGoodsListForPackBaseGoodsForPackVo
     */
    originJob?: string;
    /**
     * 商品过期日期
     * @type {string}
     * @memberof CombinedGoodsListForPackBaseGoodsForPackVo
     */
    marketExpiryDate?: string;
    /**
     * 市场商品名称
     * @type {string}
     * @memberof CombinedGoodsListForPackBaseGoodsForPackVo
     */
    marketProductName?: string;
    /**
     * 是否打印原产地
     * @type {number}
     * @memberof CombinedGoodsListForPackBaseGoodsForPackVo
     */
    originPrint?: number;
    /**
     * sku id
     * @type {number}
     * @memberof CombinedGoodsListForPackBaseGoodsForPackVo
     */
    skuId?: number;
    /**
     * sku编码
     * @type {string}
     * @memberof CombinedGoodsListForPackBaseGoodsForPackVo
     */
    skuCode?: string;
    /**
     * 是否样品商品 0 不是 1 是
     * @type {number}
     * @memberof CombinedGoodsListForPackBaseGoodsForPackVo
     */
    simple?: number;
    /**
     * 是否有样品商品 0 没有 1 有
     * @type {number}
     * @memberof CombinedGoodsListForPackBaseGoodsForPackVo
     */
    hasSimpleGoods?: number;
    /**
     * 样品商品数量
     * @type {number}
     * @memberof CombinedGoodsListForPackBaseGoodsForPackVo
     */
    simpleGoodsNumber?: number;
}

/**
 * Check if a given object implements the CombinedGoodsListForPackBaseGoodsForPackVo interface.
 */
export function instanceOfCombinedGoodsListForPackBaseGoodsForPackVo(value: object): value is CombinedGoodsListForPackBaseGoodsForPackVo {
    return true;
}

export function CombinedGoodsListForPackBaseGoodsForPackVoFromJSON(json: any): CombinedGoodsListForPackBaseGoodsForPackVo {
    return CombinedGoodsListForPackBaseGoodsForPackVoFromJSONTyped(json, false);
}

export function CombinedGoodsListForPackBaseGoodsForPackVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CombinedGoodsListForPackBaseGoodsForPackVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'imgUrl': json['imgUrl'] == null ? undefined : json['imgUrl'],
        'constructQuantity': json['constructQuantity'] == null ? undefined : json['constructQuantity'],
        'name': json['name'] == null ? undefined : json['name'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
        'color': json['color'] == null ? undefined : json['color'],
        'size': json['size'] == null ? undefined : json['size'],
        'length': json['length'] == null ? undefined : json['length'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
        'originJob': json['originJob'] == null ? undefined : json['originJob'],
        'marketExpiryDate': json['marketExpiryDate'] == null ? undefined : json['marketExpiryDate'],
        'marketProductName': json['marketProductName'] == null ? undefined : json['marketProductName'],
        'originPrint': json['originPrint'] == null ? undefined : json['originPrint'],
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'simple': json['simple'] == null ? undefined : json['simple'],
        'hasSimpleGoods': json['hasSimpleGoods'] == null ? undefined : json['hasSimpleGoods'],
        'simpleGoodsNumber': json['simpleGoodsNumber'] == null ? undefined : json['simpleGoodsNumber'],
    };
}

export function CombinedGoodsListForPackBaseGoodsForPackVoToJSON(json: any): CombinedGoodsListForPackBaseGoodsForPackVo {
    return CombinedGoodsListForPackBaseGoodsForPackVoToJSONTyped(json, false);
}

export function CombinedGoodsListForPackBaseGoodsForPackVoToJSONTyped(value?: CombinedGoodsListForPackBaseGoodsForPackVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'imgUrl': value['imgUrl'],
        'constructQuantity': value['constructQuantity'],
        'name': value['name'],
        'trackingNumber': value['trackingNumber'],
        'color': value['color'],
        'size': value['size'],
        'length': value['length'],
        'width': value['width'],
        'height': value['height'],
        'originJob': value['originJob'],
        'marketExpiryDate': value['marketExpiryDate'],
        'marketProductName': value['marketProductName'],
        'originPrint': value['originPrint'],
        'skuId': value['skuId'],
        'skuCode': value['skuCode'],
        'simple': value['simple'],
        'hasSimpleGoods': value['hasSimpleGoods'],
        'simpleGoodsNumber': value['simpleGoodsNumber'],
    };
}

